/**
 * `Ramane` — cifra-erou a zilei, cu contorul `de plata + blocat vs disponibil`.
 *
 * Intreg scopul aplicatiei e `Disponibil dupa plata = disponibil − de_plata − blocat`, comparat
 * cu zero, deci asta e singura cifra care are voie sa fie de 32px. Contorul de 8px trece pe
 * `--meter-over` peste 100%, dar procentul e scris si in litere: culoarea nu e codificarea.
 */

import type { ReactNode } from 'react';
import { Money } from './Money.tsx';

const procentFmt = new Intl.NumberFormat('ro-RO', {
  style: 'percent',
  maximumFractionDigits: 0,
});

export interface PropsHeroFigure {
  eticheta?: string;
  /** `disponibil − de_plata − blocat`, in unitati minore. */
  minor: number;
  moneda?: string;
  /** `de_plata + blocat` — ce se consuma din disponibil. */
  consumat: number;
  disponibil: number;
  detaliu?: ReactNode;
  className?: string;
}

export function HeroFigure({
  eticheta = 'Rămâne',
  minor,
  moneda = 'lei',
  consumat,
  disponibil,
  detaliu,
  className,
}: PropsHeroFigure) {
  const raport = disponibil > 0 ? consumat / disponibil : consumat > 0 ? 1.5 : 0;
  const depasit = raport > 1;
  const latime = Math.min(100, Math.max(0, raport * 100));
  const procent = procentFmt.format(raport);

  return (
    <div className={`tile ${className ?? ''}`}>
      <div className="flex items-baseline justify-between gap-2">
        <span className="text-11 font-medium tracking-wide text-ink-2 uppercase">{eticheta}</span>
        <span className="text-11 text-ink-2">
          {depasit ? 'Depășit' : 'Utilizat'} <span className="num">{procent}</span> din disponibil
        </span>
      </div>

      <Money minor={minor} moneda={moneda} className="text-32 leading-none font-medium" />

      <div
        className="meter"
        data-depasit={depasit}
        role="meter"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={Math.round(latime)}
        aria-valuetext={`${procent} din disponibil este angajat`}
        aria-label="De plată plus blocat, raportat la disponibil"
      >
        <div className="meter-fill" style={{ width: `${latime}%` }} />
      </div>

      {detaliu ? <div className="text-11 text-ink-3">{detaliu}</div> : null}
    </div>
  );
}
